module.exports = __webpack_public_path__ + "img/38.4681d188.jpg";